<template>
    <v-container v-html="html">
    </v-container>
</template>

<script>
import api from '@/plugins/api';
export default {
  name: "PaginaAvisoLegal",

  data: () => ({
    html: '',
    tipoPagina: 0
  }),



  methods: {
    obtenerTerminosCondiciones: function(idioma) {
      api.obtenerTerminosYCondicones(2,idioma)
        .then((res)=>{
          this.html = res.data.terminos.terminos.texto;
        })

      }  // fin ObtenerTerminosCondiciones


  },  // fin methods

  mounted () {
    // consulto al parking por el texto a presentar
    this.obtenerTerminosCondiciones(this.$i18n.locale.toUpperCase());
    window.scrollTo(0,0);

  },
   // fin evento mounted

};
</script>
